module.exports = __webpack_public_path__ + "img/1.635f690d.svg";